var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch, ModelSync, Prop } from 'vue-property-decorator';
import { BPagination, BOverlay } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
import TabHeading from 'components/picture-frames/Tabs/TabHeading.vue';
import MouldingSearchFilters from 'components/picture-frames/Tabs/MouldingOptions/MouldingSearchFilters.vue';
import MouldingResults from 'components/picture-frames/Tabs/MouldingOptions/MouldingResults.vue';
import { getFramePrice } from 'ts/modules/pricing';
let MouldingOptions = class MouldingOptions extends Vue {
    mouldingSelected;
    rebateDimensions;
    nonFramePrice;
    loading = true;
    currentPage = 1;
    rows = 0;
    perPage = 24;
    options = {
        itemcode: '',
        colour: null,
        profile: null,
        width: null,
        depth: null,
        rebateDepth: null,
        price: null,
        sortBy: 'favourites',
        order: 'asc'
    };
    results = [];
    get queryParams() {
        let widths = [0, 999];
        if (this.options.width) {
            widths = this.options.width.split('-').map(width => parseInt(width));
        }
        let depths = [0, 999];
        if (this.options.depth) {
            depths = this.options.depth.split('-').map(depth => parseInt(depth));
        }
        let rebateDepths = [0, 999];
        if (this.options.rebateDepth) {
            rebateDepths = this.options.rebateDepth.split('-').map(depth => parseInt(depth));
        }
        return {
            itemCode: this.options.itemcode || null,
            rebateWidth: this.rebateDimensions.width,
            rebateLength: this.rebateDimensions.length,
            where: {
                minWidth: widths[0],
                maxWidth: widths[1],
                minDepth: depths[0],
                maxDepth: depths[1],
                minRebateDepth: rebateDepths[0],
                maxRebateDepth: rebateDepths[1],
                colourID: this.options.colour ? this.options.colour : null,
                profileID: this.options.profile ? this.options.profile : null,
                priceRange: this.options.price
            },
            orderBy: this.options.sortBy,
            sortDir: this.options.order,
            page: this.currentPage,
            itemCodeChosen: this.mouldingSelected ? this.mouldingSelected.itemCode : null
        };
    }
    onOptionsChange() {
        this.currentPage = 1;
        this.debouncedSearch();
    }
    debouncedSearch = debounce(this.search, 400);
    async search() {
        this.loading = true;
        this.results = [];
        let { data } = await axios.get('/api/frameDesigner/suitableMouldings', { params: this.queryParams });
        this.results = data.data;
        if (this.mouldingSelected != null) {
            // Refresh the price of the selected
            let framePrice = await getFramePrice(this.mouldingSelected.sku, this.rebateDimensions);
            this.mouldingSelected.price = framePrice.price;
            this.results.unshift(this.mouldingSelected);
        }
        this.rows = data.total;
        this.loading = false;
        if (this.currentPage > 1) {
            // Scroll to top of results
            document.getElementById('moulding-result-container')?.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
    resetFilters() {
        this.options = { ...this.options, ...{
                itemcode: '',
                colour: null,
                profile: null,
                width: null,
                depth: null,
                rebateDepth: null,
                price: null
            } };
    }
    mounted() {
        this.search();
    }
};
__decorate([
    ModelSync('moulding', 'change', { type: Object })
], MouldingOptions.prototype, "mouldingSelected", void 0);
__decorate([
    Prop({ type: Object })
], MouldingOptions.prototype, "rebateDimensions", void 0);
__decorate([
    Prop({ type: Number })
], MouldingOptions.prototype, "nonFramePrice", void 0);
__decorate([
    Watch('options', { deep: true })
], MouldingOptions.prototype, "onOptionsChange", null);
__decorate([
    Watch('rebateDimensions', { deep: true }),
    Watch('currentPage')
], MouldingOptions.prototype, "debouncedSearch", void 0);
MouldingOptions = __decorate([
    Component({
        components: {
            BPagination, BOverlay,
            TabHeading, MouldingSearchFilters, MouldingResults
        }
    })
], MouldingOptions);
export default MouldingOptions;
